import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Container, Grid, Typography, Button } from '@material-ui/core';
import {
  OrderByOptions,
  SortOptions,
  PageReturnCountOptions,
  ViewMode,
} from 'commons/constants/KeyFlowConstants';
import { ViewModeType } from 'commons/constants/type';
import { useStyles } from 'components/SearchResult';
import { Pagination } from 'components/Pagination';
import { SpecialListView } from 'components/SpecialListView';
import { SpecialThumbnailView } from 'components/SpecialThumbnailView';
import { SquareSwitch } from 'components/Switch';
import { useWkblSpecialVideo } from 'hooks';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/reducers/type';
import { OrderSelect, PageReturnSelect } from 'components/Select';
import { addComma } from '../../commons/utils/commonUtil';

function SearchResultBySpecial() {
  const classes = useStyles();

  const { specialVideoList, isLoading, pagination, searchCondition } = useSelector(
    (state: RootState) => state.wkblSpecialVideo,
  );

  const {
    onClearWkblSpecialVideoList,
    onChangeWkblSpecialVideoPage,
    onChangeWkblSpecialVideoAsc,
    onChangeWkblSpecialVideoReturnCount,
    onChangeWkblSpecialVideoSort,
  } = useWkblSpecialVideo();

  const [viewMode, setViewMode] = useState<ViewModeType>(ViewMode.THUMBNAIL);

  const isEmptyData = useMemo(() => {
    return specialVideoList.length === 0;
  }, [specialVideoList.length]);

  useEffect(() => {
    return () => {
      onClearWkblSpecialVideoList();
    };
  }, [onClearWkblSpecialVideoList]);

  const onChangePage = useCallback(
    (pageNumber: number) => {
      onChangeWkblSpecialVideoPage(pageNumber);
    },
    [onChangeWkblSpecialVideoPage],
  );

  const onChangeViewMode = useCallback(() => {
    if (viewMode === ViewMode.LIST) {
      setViewMode(ViewMode.THUMBNAIL);
    } else {
      setViewMode(ViewMode.LIST);
    }
  }, [viewMode]);

  return (
    <Container component="article" className={classes.root}>
      <div className={classes.optionContainer}>
        <p className={classes.resultCount}>검색 결과 : {addComma(pagination.itemCount)}개</p>

        <div className={classes.searchOptionContainer}>
          <SquareSwitch onChange={onChangeViewMode} value={viewMode} />
          <OrderSelect
            asc={searchCondition.asc}
            sort={searchCondition.sort}
            onChangeAsc={onChangeWkblSpecialVideoAsc}
            onChangeSort={onChangeWkblSpecialVideoSort}
          />
          <PageReturnSelect
            returnCount={pagination.returnCount || searchCondition.retr}
            onChangeReturnCount={onChangeWkblSpecialVideoReturnCount}
          />
        </div>
      </div>
      {isEmptyData ? (
        <Grid container justifyContent="center" className={classes.emptyDataContainer}>
          <Grid item xs={4}>
            <Typography>데이터가 존재하지 않습니다.</Typography>
          </Grid>
        </Grid>
      ) : viewMode ? (
        <SpecialListView />
      ) : (
        <SpecialThumbnailView />
      )}
      <Grid container justifyContent="center">
        <Grid item xs={9} className={classes.paginationContainer}>
          <Pagination pagination={pagination} onChangePage={onChangePage} />
        </Grid>
      </Grid>
    </Container>
  );
}

export default SearchResultBySpecial;
